import {
  Component,
  Output,
  EventEmitter,
  Input,
  HostBinding,
  ChangeDetectorRef,
  ViewChild,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DataTableBodyComponent } from '@swimlane/ngx-datatable';
import { GridBodyCardRowDirective } from './card-row.directive';

@Component({
  selector: 'rbody-card-datatable-body',
  templateUrl: './body.card.html',
})
export class BodyCardComponent extends DataTableBodyComponent implements OnInit {
  @Input() rowTemplate!: GridBodyCardRowDirective;
  ngOnInit() {}
}
